var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4691_2701)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.625 14.625V14.5H13.5H12.375H12.25V14.625C12.25 14.8902 12.1446 15.1446 11.9571 15.3321C11.7696 15.5196 11.5152 15.625 11.25 15.625H3.375C3.10978 15.625 2.85543 15.5196 2.66789 15.3321C2.48036 15.1446 2.375 14.8902 2.375 14.625V6.75C2.375 6.48478 2.48036 6.23043 2.66789 6.04289C2.85543 5.85536 3.10978 5.75 3.375 5.75H3.5V5.625V4.5V4.375H3.375C2.74511 4.375 2.14102 4.62522 1.69562 5.07062C1.25022 5.51602 1 6.12011 1 6.75V14.625C1 15.2549 1.25022 15.859 1.69562 16.3044C2.14102 16.7498 2.74511 17 3.375 17H11.25C11.8799 17 12.484 16.7498 12.9294 16.3044C13.3748 15.859 13.625 15.2549 13.625 14.625Z",
    fill: "#A4A4A4",
    stroke: "#A4A4A4",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.04289 2.66789C6.23043 2.48036 6.48478 2.375 6.75 2.375H14.625C14.8902 2.375 15.1446 2.48036 15.3321 2.66789C15.5196 2.85543 15.625 3.10978 15.625 3.375V11.25C15.625 11.5152 15.5196 11.7696 15.3321 11.9571C15.1446 12.1446 14.8902 12.25 14.625 12.25H6.75C6.48478 12.25 6.23043 12.1446 6.04289 11.9571C5.85536 11.7696 5.75 11.5152 5.75 11.25V3.375C5.75 3.10978 5.85536 2.85543 6.04289 2.66789ZM14.625 1H6.75C6.12011 1 5.51602 1.25022 5.07062 1.69562C4.62522 2.14102 4.375 2.74511 4.375 3.375V11.25C4.375 11.8799 4.62522 12.484 5.07062 12.9294C5.51602 13.3748 6.12011 13.625 6.75 13.625H14.625C15.2549 13.625 15.859 13.3748 16.3044 12.9294C16.7498 12.484 17 11.8799 17 11.25V3.375C17 2.74511 16.7498 2.14102 16.3044 1.69562C15.859 1.25022 15.2549 1 14.625 1Z",
    fill: "#A4A4A4",
    stroke: "#A4A4A4",
    strokeWidth: 0.25
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4691_2701"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.22a0255452e6ba6364581df3bc3b74e3.svg";
export { ForwardRef as ReactComponent };